<!--
 * @Description: PC头部菜单
 * @Autor: WangYuan
 * @Date: 2021-05-19 14:07:29
 * @LastEditors: WangYuan
 * @LastEditTime: 2021-12-15 17:09:06
-->
<template>
  <div>
    <div class="topBar">
      <!-- 左侧内容 -->
      <div>
        <span v-if="isBack" id="faker-to-back" @click="toPagesManage">
          <i class="el-icon-arrow-left"></i>
          <span class="f14 pointer">返回</span>
        </span>
        <!--<span class="f14 pointer ml20" @click="back">切换应用</span>-->
      </div>

      <!-- 右侧内容 -->
      <div style="margin-right: 2vw">
        <!-- <git-control />
        <el-button size="small" @click="toSchema">schema 生成器</el-button>

        <el-button size="small ml10" @click="viewQr">商城二维码</el-button> -->

        <el-button size="small ml10" icon="el-icon-view" @click="show = true">实时预览</el-button>

        <el-button size="small f-white bg-theme" icon="el-icon-tickets" id="faker-to-save"
          @click="openSave">保存</el-button>

        <!--<el-button size="small ml10" @click="onLogout">退出</el-button>-->
        <el-button size="small ml10" @click="back">切换应用</el-button>
      </div>
    </div>

    <real-timeView :show.sync="show"></real-timeView>

    <save-dialog ref="save"></save-dialog>

    <qr-dialog ref="qr"></qr-dialog>
  </div>
</template>

<script>
import RealTimeView from "./RealTimeView.vue";
import SaveDialog from "@/components/SaveDialog";
import QrDialog from "@/components/QrDialog";
import jrQrcode from "jr-qrcode";
import { mapGetters, mapMutations } from "vuex";
import { editProject, pageSave, shopUpdate } from "@/api/project";
import { getProjectDetail } from "@/api/easyApp";
import { deepClone } from "../../js/utils";

export default {
  components: {
    RealTimeView,
    SaveDialog,
    QrDialog,
  },

  provide() {
    return {
      topBar: this,
      issave: false,
    };
  },
  data() {
    return {
      show: false,
      isBack: false,
    };
  },

  computed: {
    ...mapGetters(["project", "userInfo", "curPage"]),
  },

  watch: {
    "$route.path": {
      handler() {
        if (this.$route.path == "/mall/page-build") {
          this.isBack = true;
        } else {
          this.isBack = false;
        }
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    //console.log("this.issavethis.issavethis.issave:",this.issave);
  },

  methods: {
    ...mapMutations(["logout", "setProject"]),
    // 返回商城管理
    back() {
      this.$router.push({ name: "managet" });
    },

    openSave(view = false) {
      // this.$refs.save.open(view);

      this.project.pagesEntityList.forEach((ele) => {
        if (ele.pagesId == this.curPage.pagesId) {
          ele.componentEntityList = this.curPage.componentEntityList;
        }
      });

      if (this.curPage.pagesId) {
        let linkPoints = [];
        let params = deepClone(this.curPage);
        params.backgroundColor = JSON.stringify(params.backgroundColor);

        // 保存
        let data = { ...params };

        //存储点位跳转
        let index = this.curPage.componentEntityList.findIndex(
          (item) =>
            item.component == "McTagNav" ||
            item.component == "McQuestionBankExercise"
        );
        //如果含有 “McTagNav”  就去循环获取这个标签导航到底是单例还是多例(自动+自定义循环之后得到)
        if (index != -1) {
          for (const i in this.curPage.componentEntityList) {
            if (this.curPage.componentEntityList[i].component == "McTagNav") {
              let comList = [];
              if (
                this.curPage.componentEntityList[i].otherSet.tagGroupSet ==
                "auto"
              ) {
                let components1 =
                  this.curPage.componentEntityList[i].otherSet.components;
                if (typeof components1 == "object") {
                  //console.log("数组合并");
                  comList = Array.from(new Set([...comList, ...components1]));
                } else {
                  comList = [components1];
                }
              } else if (
                this.curPage.componentEntityList[i].otherSet.tagGroupSet ==
                "hand"
              ) {
                let components1 =
                  this.curPage.componentEntityList[i].otherSet.components;
                console.log("手动关联的组件components1:", components1);
                if (typeof components1 == "object") {
                  comList = Array.from(new Set([...comList, ...components1]));
                } else {
                  comList = [components1];
                }
              }

              //循环一下
              if (
                this.curPage.componentEntityList[i].otherSet.selfCategory
                  .length > 0
              ) {
                for (const j in this.curPage.componentEntityList[i].otherSet
                  .selfCategory) {
                  console.log(
                    this.curPage.componentEntityList[i].otherSet.selfCategory[j]
                      .components
                  );
                  //如果自定义的组件关联的是单个
                  console.log(
                    "自定义组件关联的组件:",
                    typeof this.curPage.componentEntityList[i].otherSet
                      .selfCategory[j].components
                  );

                  if (
                    typeof this.curPage.componentEntityList[i].otherSet
                      .selfCategory[j].components == "object"
                  ) {
                    console.log("数组合并");
                    //comList=comList.concat(this.curPage.componentEntityList[i].otherSet.selfCategory[j].components);
                    comList = Array.from(
                      new Set([
                        ...comList,
                        ...this.curPage.componentEntityList[i].otherSet
                          .selfCategory[j].components,
                      ])
                    );
                  } else {
                    if (
                      !comList.includes(
                        this.curPage.componentEntityList[i].otherSet
                          .selfCategory[j].components
                      )
                    ) {
                      comList = [
                        ...comList,
                        this.curPage.componentEntityList[i].otherSet
                          .selfCategory[j].components,
                      ];
                    }
                  }
                }
                console.log(
                  "this.curPage.componentEntityList[i]:",
                  this.curPage.componentEntityList[i]
                );
                console.log("==comList==:", comList);

                if (comList.length > 1) {
                  this.curPage.componentEntityList[i].otherSet.tagShowType =
                    "multiple";
                  //tagShowType
                } else {
                  this.curPage.componentEntityList[i].otherSet.tagShowType =
                    "single";
                }
              }

              if (
                this.curPage.componentEntityList[i].otherSet.supportLink == true
              ) {
                let res = this.btnGetLinkPoints(i);

                if (res != null) {
                  linkPoints = [...linkPoints, ...res];
                }

                //linkPoints = JSON.stringify(linkPoints);
              }
            }
            //练习进度点位
            else if (
              this.curPage.componentEntityList[i].component ==
              "McQuestionBankExercise" &&
              this.curPage.componentEntityList[i].attrs.supportPointLink == true
            ) {
              let res = this.getPositionParameters();

              if (res != null) {
                linkPoints = [...linkPoints, ...res];
              }
            }
          }

          console.log("==linkPoints==:", linkPoints);
          if (linkPoints.length > 0) {
            data["linkPoints"] = JSON.stringify(linkPoints);
          } else {
            data["linkPoints"] = null;
          }
        } else {
          data["linkPoints"] = null;
        }
        //存储数据源传参 McArticle(value)  McArtDetail(value)  McStudys(attrs) McCourseDetail
        let initIndex = this.curPage.componentEntityList.findIndex(
          (item) =>
            (item.value &&
              item.value.dataSource &&
              item.value.dataSource.relationParams) ||
            (item.attrs &&
              item.attrs.dataSource &&
              item.attrs.dataSource.relationParams)
        );

        if (initIndex == -1) {
          data["dsInitParams"] = null;
        } else {
          let dsInitParams = this.btnGetInitParams();
          if (dsInitParams.length > 0) {
            data["dsInitParams"] = JSON.stringify(dsInitParams);
          } else {
            data["dsInitParams"] = null;
          }
        }

        delete data.componentListJson;
        console.log("编辑传递参数");

        let data1 = deepClone(data);
        shopUpdate(data1)
          .then((res) => {
            if (res.code == 0) {
              this.$message({ message: "保存成功", type: "warning" });
              this.issave = true;
              this.setProject(this.project);
            }
          })
          .catch((err) => {
            this.$message.error(err.msg);
          });
      } else {
        if (!this.curPage.pagesId) {
          this.$message({ message: "没更改任何页面", type: "success" });
          return;
        }

        let data = deepClone(this.curPage);

        delete data.componentListJson;
        console.log("新增传递参数");

        pageSave(data)
          .then((res) => {
            if (res.code == 0) {
              this.$message({ message: "保存成功", type: "success" });
              this.issave = true;
              this.getProject();
              this.setProject(this.project);
            }
          })
          .catch((err) => {
            this.$message.error(err.msg);
          });
      }
    },

    getPositionParameters() {
      let index = this.curPage.componentEntityList.findIndex(
        (item) => item.component == "McQuestionBankExercise"
      );
      if (this.curPage.componentEntityList[index].attrs.pageType == "examine") {
        let list = [
          {
            id: this.curPage.componentEntityList[index].id,
            type: "custom",
            sign: "id",
            name: "name",
            title: "类型",
            data: [
              {
                sign: "id",
                key: "orderId",
                value: "examine",
                slot: "testExamination",
                name: "模拟考试",
                cvalue: "&ruleSign=rule1&orderId=",
              },
            ],
          },
        ];
        return list;
      } else {
        let list = [
          {
            id: this.curPage.componentEntityList[index].id,
            type: "custom",
            sign: "id",
            name: "name",
            title: "类型",
            data: [
              {
                sign: "id",
                key: "questionBankId",
                value: "collect",
                slot: "testPractice",
                name: "我的收藏",
                cvalue: "&needRandom=false&nameSpace=collect&questionBankId=",
              },
              {
                sign: "id",
                key: "questionBankId",
                value: "mistakes",
                slot: "testPractice",
                name: "练习错题",
                cvalue: "&needRandom=false&nameSpace=mistakes&questionBankId=",
              },
              {
                sign: "id",
                key: "questionBankId",
                value: "random",
                slot: "testPractice",
                name: "随机练习",
                cvalue: "&needRandom=true&questionBankId=",
              },
              {
                sign: "id",
                key: "questionBankId",
                value: "exercise",
                slot: "testPractice",
                name: "顺序练习",
                cvalue: "&needRandom=false&questionBankId=",
              },
            ],
          },
        ];
        return list;
      }
    },

    //获取点位参数
    btnGetLinkPoints(index) {
      //let index = this.curPage.componentEntityList.findIndex((item) => item.component == 'McTagNav');

      //保存点位跳转
      let linkPoints = [];

      if (
        this.curPage.componentEntityList[index].otherSet.tagGroupSet == "auto"
      ) {
        let clickId = this.curPage.componentEntityList[index].otherSet.clickId;
        let showName =
          this.curPage.componentEntityList[index].otherSet.showName;
        let title =
          this.curPage.componentEntityList[index].otherSet.signChinaName;
        console.log(
          "this.curPage.componentEntityList[index].otherSet:",
          this.curPage.componentEntityList[index].otherSet
        );
        let showLevel =
          this.curPage.componentEntityList[index].otherSet.showLevel; //显示层级
        let children =
          this.curPage.componentEntityList[index].otherSet.children; //子级字段

        linkPoints = [
          {
            id: this.curPage.componentEntityList[index].id,
            type: "remote",
            sign: clickId,
            name: showName,
            title: title,
            showLevel: !showLevel ? false : showLevel,
            children: !children ? false : children,
            url: this.curPage.componentEntityList[index].otherSet.tagSource,
            groupModel:
              this.curPage.componentEntityList[index].otherSet.groupModel,
            components:
              this.curPage.componentEntityList[index].otherSet.components,
          },
        ];
      } else if (
        this.curPage.componentEntityList[index].otherSet.tagGroupSet == "hand"
      ) {
        let clickId = this.curPage.componentEntityList[index].otherSet.clickId;
        let showName =
          this.curPage.componentEntityList[index].otherSet.showName;
        let title =
          this.curPage.componentEntityList[index].otherSet.signChinaName;

        linkPoints = [
          {
            id: this.curPage.componentEntityList[index].id,
            type: "custom",
            sign: clickId,
            name: showName,
            title: title,
            data: [],
          },
        ];

        console.log("clickId:", clickId);

        for (const i in this.curPage.componentEntityList[index].otherSet
          .categoryList) {
          let obj = {
            sign: clickId,
            value:
              this.curPage.componentEntityList[index].otherSet.categoryList[i][
              clickId
              ],
            name: this.curPage.componentEntityList[index].otherSet.categoryList[
              i
            ][showName],
            components:
              this.curPage.componentEntityList[index].otherSet.components,
          };
          linkPoints[0].data.push(obj);
        }
      } else if (
        this.curPage.componentEntityList[index].otherSet.tagGroupSet ==
        "selfSet" &&
        this.curPage.componentEntityList[index].otherSet.tagShowType == "single"
      ) {
        let clickId = this.curPage.componentEntityList[index].otherSet.sign;
        let title =
          this.curPage.componentEntityList[index].otherSet.signSelfSetChinaName;

        linkPoints = [
          {
            id: this.curPage.componentEntityList[index].id,
            type: "custom",
            sign: clickId,
            name: "name",
            title: title,
            data: [],
          },
        ];

        for (const i in this.curPage.componentEntityList[index].otherSet
          .selfCategory) {
          let obj = {
            sign: this.curPage.componentEntityList[index].otherSet.sign,
            value:
              this.curPage.componentEntityList[index].otherSet.selfCategory[i]
                .value,
            name: this.curPage.componentEntityList[index].otherSet.selfCategory[
              i
            ].name,
            components:
              this.curPage.componentEntityList[index].otherSet.components,
          };
          linkPoints[0].data.push(obj);
        }

        console.log("单例点位存:", linkPoints);
      } else if (
        this.curPage.componentEntityList[index].otherSet.tagGroupSet ==
        "selfSet" &&
        this.curPage.componentEntityList[index].otherSet.tagShowType != "single"
      ) {
        let clickId = "navIndex";
        let title =
          this.curPage.componentEntityList[index].otherSet.signSelfSetChinaName;

        linkPoints = [
          {
            id: this.curPage.componentEntityList[index].id,
            type: "custom",
            sign: clickId,
            name: "name",
            title: title,
            data: [],
          },
        ];

        for (const i in this.curPage.componentEntityList[index].otherSet
          .selfCategory) {
          let obj = {
            sign: clickId,
            value: i,
            name: this.curPage.componentEntityList[index].otherSet.selfCategory[
              i
            ].name,
            components:
              this.curPage.componentEntityList[index].otherSet.selfCategory[i]
                .components,
          };
          linkPoints[0].data.push(obj);
        }

        console.log("单例点位存:", linkPoints);
      } else if (
        this.curPage.componentEntityList[index].otherSet.tagShowType ==
        "multiple" ||
        this.curPage.componentEntityList[index].otherSet.tagShowType == "single"
      ) {
        let clickId = "navIndex";
        let title =
          this.curPage.componentEntityList[index].otherSet.signSelfSetChinaName;

        linkPoints = [
          {
            id: this.curPage.componentEntityList[index].id,
            type: "custom",
            sign: clickId,
            name: "name",
            title: title,
            data: [],
          },
        ];

        for (const i in this.curPage.componentEntityList[index].otherSet
          .selfCategory) {
          let obj = {
            sign: clickId,
            value: i,
            name: this.curPage.componentEntityList[index].otherSet.selfCategory[
              i
            ].name,
            components:
              this.curPage.componentEntityList[index].otherSet.selfCategory[i]
                .components,
          };
          linkPoints[0].data.push(obj);
        }
      }

      if (linkPoints.length > 0) {
        //linkPoints = JSON.stringify(linkPoints);
        return linkPoints;
      } else {
        return null;
      }
    },
    //获取初始化入参参数
    btnGetInitParams() {
      //relationParams
      let componentEntityList = this.curPage.componentEntityList;

      let dsInitParams = [];

      for (const i in componentEntityList) {
        /*  "{组件-id}": {
            "{数据源}": {
              "{前置参数名0}": "{前置选择器数据源标识0}",
                  "{前置参数名1}": "{前置选择器数据源标识1}"
            }
          }*/
        //文章详情

        if (
          componentEntityList[i].value &&
          componentEntityList[i].value.dataSource &&
          componentEntityList[i].value.dataSource.relationParams
        ) {
          let obj = {
            componentId: componentEntityList[i].id,
            tagetSource: componentEntityList[i].value.dataSource.tagetSource,
            relationParams:
              componentEntityList[i].value.dataSource.relationParams,
          };

          dsInitParams.push(obj);
        } else if (
          componentEntityList[i].attrs &&
          componentEntityList[i].attrs.dataSource &&
          componentEntityList[i].attrs.dataSource.relationParams
        ) {
          let obj = {
            componentId: componentEntityList[i].id,
            tagetSource: componentEntityList[i].attrs.dataSource.tagetSource,
            relationParams:
              componentEntityList[i].attrs.dataSource.relationParams,
          };
          dsInitParams.push(obj);
        }
      }

      console.log("dsInitParamsxxxxxx:", dsInitParams);

      return dsInitParams;
    },

    toSchema() {
      let { href } = this.$router.resolve({
        path: "/schema",
      });
      window.open(href);
    },

    toPagesManage() {
      // console.log("this.issave:",this.issave);
      this.$router.go(-1);
      // if (!this.issave) {
      //   this.$confirm("您的修改还未保存，确定要离开此页面吗?", "", {
      //     confirmButtonText: "确认",
      //     cancelButtonText: "取消",
      //     type: "warning",
      //   })
      //     .then(() => {
      //       this.$router.push({ name: "pages-manage" });

      //       this.issave = false;
      //     })
      //     .catch(() => { });
      // } else {
      //   this.$router.push({ name: "pages-manage" });
      //   this.issave = false;
      // }
    },

    viewQr() {
      this.issave = true;
      this.$confirm("如不更新，则预览为上次保存的项目数据?", "是否更新保存", {
        confirmButtonText: "更新保存",
        cancelButtonText: "不更新",
        type: "warning",
      })
        .then(() => {
          this.openSave(true);
          this.issave = false;
        })
        .catch(() => {
          this.openQr();
        });
    },

    openQr() {
      this.$refs.qr.open();
    },

    // 保存
    async save() {
      let data = {
        aid: this.project.aid,
        userId: this.userInfo.userId,
        name: this.project.name,
        richText: JSON.stringify(this.project),
      };

      let { code } = await editProject(data);

      if (code == "0")
        this.$notify({
          title: "成功",
          message: "项目保存成功",
          type: "success",
        });
    },

    // 退出
    onLogout() {
      this.$confirm("是否确定退出平台?", "退出", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.logout();
        this.$router.push({ name: "login" });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.topBar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  width: 100%;
  padding: 0 20px;
  background: #fff;
  border-bottom: 1px solid #ebedf0;
}
</style>
